// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.segment-content {
  padding: 0;
  margin: 20px 0;
}

ion-segment-button {
  --background: transparent;
  --color: inherit;
  --background-checked: var(--ion-color-secondary);
  --color-checked: var(--planeed-color-white);
  --border-radius: 20px;
  --padding-start: 15px;
  --padding-end: 15px;
  --indicator-color: transparent;
  --indicator-box-shadow: none;
  --border-width: 0;
  flex: 0 0 auto;
  margin-left: 10px;
  margin-right: 10px;
}

.segment-content {
  overflow-x: auto;
  white-space: nowrap;
}
.segment-content ion-segment {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  overflow-x: auto;
  cursor: grab;
}
.segment-content ion-segment.dragging {
  cursor: grabbing;
}
.segment-content ion-segment::-webkit-scrollbar {
  display: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
